import { Avatar as AvatarPrimitive } from "radix-ui";
import { cn } from "~/foundation/utils/cn";

export interface AvatarProps {
  name: string;
  src?: string | null;
  size?: 24 | 28 | 32 | 96;
  className?: string;
}

function initials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) {
    return "?";
  }
  const first = parts[0]?.[0] ?? "";
  const last = parts.length > 1 ? (parts[parts.length - 1]?.[0] ?? "") : "";
  return (first + last).toUpperCase();
}

export function Avatar({ name, src, size = 28, className }: AvatarProps) {
  return (
    <AvatarPrimitive.Root
      className={cn(
        "inline-flex shrink-0 select-none items-center justify-center overflow-hidden rounded-full",
        className,
      )}
      style={{ width: size, height: size }}
    >
      {src ? (
        <AvatarPrimitive.Image src={src} alt={name} className="size-full object-cover" />
      ) : null}
      {/* No delay without a src: there is no image race to wait out. */}
      <AvatarPrimitive.Fallback
        {...(src ? { delayMs: 300 } : {})}
        className="flex size-full items-center justify-center bg-accent font-medium text-accent-text"
        style={{ fontSize: Math.round(size * 0.4) }}
      >
        {initials(name)}
      </AvatarPrimitive.Fallback>
    </AvatarPrimitive.Root>
  );
}
